import { render, staticRenderFns } from "./AdminUserManage.vue?vue&type=template&id=1c535c94&scoped=true&"
import script from "./AdminUserManage.vue?vue&type=script&lang=js&"
export * from "./AdminUserManage.vue?vue&type=script&lang=js&"
import style0 from "./AdminUserManage.vue?vue&type=style&index=0&id=1c535c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c535c94",
  null
  
)

export default component.exports